import React, { useState, useContext } from 'react';
import classNames from 'classnames';

import { Link, NavLink } from 'react-router-dom';
import { Context } from '../context';

type Props = {
  to: string;
  text: string;
  setOpenMenu: (x: boolean) => void
};

const NavigateLink: React.FC<Props> = ({ to, text, setOpenMenu }) => (
  <NavLink
    to={to}
    className={({ isActive }) => classNames(
      'nav__link',
      { 'nav__link--active': isActive },
    )}
    onClick={() => {
      setOpenMenu(false);
    }}
  >
    {text}
  </NavLink>
);

export const Nav: React.FC = () => {
  const { cart, favorite } = useContext(Context);
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <header>
      <nav className="nav">
        <ul className="nav__items">
          <button
            type="button"
            onClick={() => {
              setOpenMenu(true);
            }}
            className="nav__button__link"
          >
            <svg
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="nav__button"
            >
              <path
                d="M0 14.6667C0 15.403 0.596954 16 1.33333
                16H22.6667C23.403 16 24 15.403 24 14.6667C24
                13.9303 23.403 13.3333 22.6667 13.3333H1.33333C0.596954
                13.3333 0 13.9303 0 14.6667ZM0 8C0 8.73638 0.596954 9.33333
                1.33333 9.33333H22.6667C23.403 9.33333 24 8.73638 24
                8C24 7.26362 23.403 6.66667 22.6667 6.66667H1.33333C0.596954
                6.66667 0 7.26362 0 8ZM1.33333 0C0.596954 0 0 0.596954 0
                1.33333C0 2.06971 0.596954 2.66667 1.33333
                2.66667H22.6667C23.403 2.66667 24 2.06971 24
                1.33333C24 0.596954 23.403 0 22.6667 0H1.33333Z"
                fill="#000"
              />
            </svg>
          </button>
          <ul
            className={classNames(
              'nav__links',
              { 'nav__links--open': openMenu },
            )}
          >
            <button
              type="button"
              onClick={() => {
                setOpenMenu(false);
              }}
              className="nav__button-in-menu"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="nav__button"
              >
                <path
                  d="M15.1943 2.41714C15.6393 1.97216 15.6393 1.2507 15.1943
                  0.805714C14.7493 0.36073 14.0278 0.360731 13.5829 0.805714L8
                  6.38857L2.41714 0.805715C1.97216 0.360732 1.2507 0.36073
                  0.805714 0.805714C0.36073 1.2507 0.360731 1.97216 0.805714
                  2.41714L6.38857 8L0.805715 13.5829C0.360732 14.0278 0.36073
                  14.7493 0.805714 15.1943C1.2507 15.6393 1.97216 15.6393
                  2.41714 15.1943L8 9.61143L13.5829 15.1943C14.0278 15.6393
                  14.7493 15.6393 15.1943 15.1943C15.6393 14.7493 15.6393
                  14.0278 15.1943 13.5829L9.61143 8L15.1943 2.41714Z"
                  fill="#1D1D1D"
                />
              </svg>
            </button>
            <li>
              <Link to="/" className="logo">
                <svg
                  width="40"
                  height="11"
                  viewBox="0 0 40 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="nav__logo"
                >
                  <path
                    d="
                      M2.93333 8.0966V0.254421H0V10.7306H6.65986V8.0966H2.93333Z
                    "
                    fill="#313237"
                  />
                  <path
                    d="M11.6842 11C15.0516 11 17.4461 8.7102 17.4461
                    5.50748C17.4461 2.2898 15.0516 0 11.6842 0C8.31688
                    0 5.92232 2.30476 5.92232 5.50748C5.92232 8.69524
                    8.31688 11 11.6842 11ZM11.6842 8.32109C10.0978
                    8.32109 8.91552 7.12381 8.91552 5.50748C8.91552
                    3.87619 10.0978 2.67891 11.6842 2.67891C13.2856
                    2.67891 14.438 3.86122 14.438 5.50748C14.438 7.13878
                    13.2856 8.32109 11.6842 8.32109Z"
                    fill="#313237"
                  />
                  <path
                    d="M22.535 5.13333V6.95918H25.1391C24.8099
                    7.76735 23.867 8.30612 22.7595 8.30612C21.1731
                    8.30612 20.1405 7.16871 20.1405 5.50748C20.1405
                    3.83129 21.1881 2.69388 22.7595 2.69388C23.8221
                    2.69388 24.765 3.26258 25.1391 4.14558H28.1772C27.7282
                    1.72109 25.4833 0 22.7296 0C19.5119 0 17.1772 2.31973
                    17.1772 5.50748C17.1772 8.69524 19.5568 11 22.7595
                    11C26.0371 11 28.282 8.56054 28.282 5.13333H22.535Z"
                    fill="#313237"
                  />
                  <path
                    d="M33.7555 11C37.1229 11 39.5175 8.7102
                    39.5175 5.50748C39.5175 2.2898 37.1229 0
                    33.7555 0C30.3882 0 27.9936 2.30476 27.9936
                    5.50748C27.9936 8.69524 30.3882 11 33.7555 11ZM33.7555
                    8.32109C32.1692 8.32109 30.9868 7.12381 30.9868
                    5.50748C30.9868 3.87619 32.1692 2.67891 33.7555
                    2.67891C35.3569 2.67891 36.5093 3.86122 36.5093
                    5.50748C36.5093 7.13878 35.3569 8.32109 33.7555 8.32109Z"
                    fill="#313237"
                  />
                </svg>
              </Link>
            </li>
            <li>
              <NavigateLink to="/" text="home" setOpenMenu={setOpenMenu} />
            </li>
            <li>
              <NavigateLink
                to="/phones"
                text="Phones"
                setOpenMenu={setOpenMenu}
              />
            </li>
            <li>
              <NavigateLink
                to="/tablets"
                text="tablets"
                setOpenMenu={setOpenMenu}
              />
            </li>
            <li>
              <NavigateLink
                to="/accessories"
                text="accessories"
                setOpenMenu={setOpenMenu}
              />
            </li>
          </ul>
          <li className="nav__like-basket">
            <NavLink
              to="/favorites"
              className={({ isActive }) => classNames(
                'nav__icon',
                { 'nav__icon--active': isActive },
              )}
            >
              {favorite && favorite?.length > 0
                && <div className="counterCart">{favorite.length}</div>}

              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.62852 0.631371C10.1584 0.411797 10.7264
                  0.298782 11.3 0.298782C11.8737 0.298782 12.4416
                  0.411797 12.9716 0.631371C13.5015 0.850945 13.983
                  1.17277 14.3885 1.57847C14.7941 1.98394 15.1158
                  2.46532 15.3353 2.99514C15.5549 3.52506 15.6679
                  4.09305 15.6679 4.66667C15.6679 5.24028 15.5549
                  5.80827 15.3353 6.33819C15.1158 6.86806 14.794 7.34949
                  14.3884 7.75497C14.3883 7.75501 14.3884 7.75493 14.3884
                  7.75497L8.49502 13.6483C8.22165 13.9217 7.77844 13.9217
                  7.50507 13.6483L1.61174 7.75497C0.792668 6.9359 0.33252
                  5.82501 0.33252 4.66667C0.33252 3.50833 0.792668 2.39743
                  1.61174 1.57836C2.43081 0.759288 3.54171 0.299139 4.70005
                  0.299139C5.85839 0.299139 6.96928 0.759288 7.78835
                  1.57836L8.00005 1.79005L8.21162 1.57847C8.21166
                  1.57844 8.21158 1.57851 8.21162 1.57847C8.61711
                  1.17283 9.09865 0.850924 9.62852 0.631371ZM13.3983
                  2.56819C13.1228 2.29256 12.7957 2.07392 12.4357
                  1.92474C12.0756 1.77556 11.6898 1.69878 11.3
                  1.69878C10.9103 1.69878 10.5245 1.77556 10.1644
                  1.92474C9.80441 2.07392 9.4773 2.29256 9.2018
                  2.56819L8.49502 3.27497C8.22165 3.54834 7.77844
                  3.54834 7.50507 3.27497L6.7984 2.56831C6.24189
                  2.01179 5.48708 1.69914 4.70005 1.69914C3.91301
                  1.69914 3.15821 2.01179 2.60169 2.56831C2.04517
                  3.12483 1.73252 3.87963 1.73252 4.66667C1.73252
                  5.4537 2.04517 6.20851 2.60169 6.76502L8.00005
                  12.1634L13.3984 6.76502C13.674 6.48953 13.8928
                  6.16231 14.042 5.80228C14.1911 5.44226 14.2679
                  5.05637 14.2679 4.66667C14.2679 4.27696 14.1911
                  3.89107 14.042 3.53105C13.8928 3.17103 13.6739
                  2.84369 13.3983 2.56819Z"
                  fill="#313237"
                />
              </svg>
            </NavLink>
            <NavLink
              to="/cart"
              className={({ isActive }) => classNames(
                'nav__icon',
                { 'nav__icon--active': isActive },
              )}
            >
              {cart && <div className="counterCart">{cart.length}</div>}
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.46683 0.933323C2.59273 0.765453 2.79032 0.666656
                  3.00016 0.666656H11.0002C11.21 0.666656 11.4076 0.765453
                  11.5335 0.933323L13.5335 3.59999C13.62 3.71539 13.6668
                  3.85574 13.6668 3.99999V13.3333C13.6668 13.8638 13.4561
                  14.3725 13.081 14.7475C12.706 15.1226 12.1973 15.3333
                  11.6668 15.3333H2.3335C1.80306 15.3333 1.29436 15.1226
                  0.919282 14.7475C0.54421 14.3725 0.333496 13.8638 0.333496
                  13.3333V3.99999C0.333496 3.85574 0.380281 3.71539 0.466829
                  3.59999L2.46683 0.933323ZM3.3335 1.99999L1.66683
                  4.22221V13.3333C1.66683 13.5101 1.73707 13.6797 1.86209
                  13.8047C1.98712 13.9298 2.15669 14 2.3335 14H11.6668C11.8436
                  14 12.0132 13.9298 12.1382 13.8047C12.2633 13.6797 12.3335
                  13.5101 12.3335 13.3333V4.22221L10.6668 1.99999H3.3335Z"
                  fill="#313237"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.333496 4.00001C0.333496 3.63182 0.631973
                  3.33334 1.00016 3.33334H13.0002C13.3684 3.33334
                  13.6668 3.63182 13.6668 4.00001C13.6668 4.3682
                  13.3684 4.66668 13.0002 4.66668H1.00016C0.631973
                  4.66668 0.333496 4.3682 0.333496 4.00001Z"
                  fill="#313237"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.33341 6C4.7016 6 5.00008 6.29848 5.00008
                  6.66667C5.00008 7.1971 5.21079 7.70581 5.58587
                  8.08088C5.96094 8.45595 6.46965 8.66667 7.00008
                  8.66667C7.53051 8.66667 8.03922 8.45595 8.41429
                  8.08088C8.78937 7.70581 9.00008 7.1971 9.00008
                  6.66667C9.00008 6.29848 9.29856 6 9.66675 6C10.0349
                  6 10.3334 6.29848 10.3334 6.66667C10.3334 7.55072
                  9.98222 8.39857 9.3571 9.02369C8.73198 9.64881
                  7.88414 10 7.00008 10C6.11603 10 5.26818 9.64881
                  4.64306 9.02369C4.01794 8.39857 3.66675 7.55072
                  3.66675 6.66667C3.66675 6.29848 3.96522 6 4.33341 6Z"
                  fill="#313237"
                />
              </svg>
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};
